import { ToastMethods } from "components/ToastNotification";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { authRepository } from "repositories";

export const useTokenVerification = (authToken: string | null): void => {
  const { t } = useTranslation("toast");

  const authTokenIsSet = !!authToken;
  const { enableActiveSessionTokenValidation, activeSessionTokenValidationIntervalSeconds } =
    useFeatureFlags();

  const triggerTokenValidation = useCallback(() => {
    console.debug("Validating if access token is still valid...");
    authRepository.verifyAccessToken().catch(() => {
      ToastMethods.showToast(t("user.verifyAccessToken.error"), "error");
    });
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    // If user is logged in and the feature flag is enabled, trigger token check in regular
    // intervals of 10 seconds (or custom amount of seconds defined in ConfigCat)
    if (enableActiveSessionTokenValidation && authTokenIsSet) {
      console.debug("Setting interval to perform token verification checks...");
      const intervalSeconds = +activeSessionTokenValidationIntervalSeconds || 10;
      interval = setInterval(triggerTokenValidation, intervalSeconds * 1000);
    }

    // Automatically stop interval if the user is not logged in or the feature flag is disabled
    return () => {
      if (interval) {
        console.debug("Deleting interval to avoid further token verification checks...");
        clearInterval(interval);
      }
    };
  }, [
    enableActiveSessionTokenValidation,
    activeSessionTokenValidationIntervalSeconds,
    authTokenIsSet,
  ]);
};

export default useTokenVerification;
